/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { handleActions } from 'redux-actions';
import { READY, SELECT_PLAYLIST_ENTRY } from '../../actions/types';
import { playlist } from '@/config';
import { toPlayerTime } from '@/utils/time';

const INITIAL_STATE = null;

const active = (state, payload) => state.map((item, index) => ({ ...item, active: payload === index }));

export const reducer = handleActions(
  {
    [READY]: (state, { payload }) => state
      || playlist(payload).map(item => ({
        ...item,
        duration: toPlayerTime(item.duration),
        active: false,
      })),
    [SELECT_PLAYLIST_ENTRY]: (state, { payload: { index } }) => state && active(state, index),
  },
  INITIAL_STATE,
);
